<div class="search-result" [ngClass]="backgroundClass">
    <div class="result-header">
        <div class="result-type-badge load">
            <mat-icon>package_2</mat-icon>
            <span class="badge-label">Load</span>
        </div>
        <div class="action-buttons" (click)="$event.stopPropagation()">
            <button
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                (click)="loadTrackButton()"
                matTooltip="Load Track"
                [routerLink]="'dispatch/track/' + item().ID">
                <fa-icon icon="location-arrow" size="lg"></fa-icon>
            </button>
            <button
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                (click)="settlementButton()"
                matTooltip="Settlement"
                [routerLink]="'dispatch/settlement/' + item().ID">
                <mat-icon class="no-margin">account_balance</mat-icon>
            </button>
            <button
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                (click)="orderGridButton()"
                matTooltip="Order Grid"
                [routerLink]="'dispatch/orders'"
                [queryParams]="{ LoadNumber: item().LoadNumber }">
                <mat-icon class="no-margin">description</mat-icon>
            </button>
            <button
                matMiniFab
                color="primary"
                class="d-none d-lg-block mat-green"
                (click)="checkinButton()"
                matTooltip="Checkin">
                <mat-icon class="no-margin">event_available</mat-icon>
            </button>
            <button
                matMiniFab
                color="primary"
                class="d-block d-lg-none"
                aria-label="toggle load menu button"
                [matMenuTriggerFor]="loadMenu">
                <mat-icon class="no-margin">menu</mat-icon>
            </button>
        </div>
        @if (item().Status) {
            <div class="status-badge" [ngClass]="statusColor(item().Status)">{{ item().Status }}</div>
        }
    </div>

    <div class="result-primary">
        <div class="result-id" [highlight]="searchTerm()">{{ primaryId }}</div>
        <div class="result-meta text-muted">{{ metaLine }}</div>
    </div>

    <div class="result-details load-details">
        <div class="detail-row">
            <div class="detail-item">
                <mat-icon class="detail-icon text-muted">people</mat-icon>
                <span class="detail-label text-muted">Customer:</span>
                <span class="detail-value" [highlight]="searchTerm()">
                    {{ item().CustomerID }} - {{ item().Customer }}
                </span>
            </div>
        </div>

        <div class="detail-row">
            <div class="detail-item">
                <mat-icon class="detail-icon text-muted">local_shipping</mat-icon>
                <span class="detail-label text-muted">Carrier:</span>
                <span class="detail-value" [highlight]="searchTerm()">
                    @if (item().CarrierID == 0 || item().CarrierName.trim() == "" || item().CarrierName == null) {
                        N/A
                    } @else {
                        {{ item().CarrierID }} - {{ item().CarrierName }}
                    }
                </span>
            </div>
        </div>

        <div class="detail-grid">
            <div class="detail-item">
                <span class="detail-label text-muted">PO:</span>
                <span class="detail-value" [highlight]="searchTerm()">{{ item().PONumbers || "N/A" }}</span>
            </div>
            <div class="detail-item">
                <span class="detail-label text-muted">Pickup #:</span>
                <span class="detail-value" [highlight]="searchTerm()">{{ item().PickupNumber || "N/A" }}</span>
            </div>
        </div>

        <div class="detail-grid">
            @if (item().RefNumbers?.length != 0) {
                <div class="detail-item">
                    <span class="detail-label text-muted">All Refs:</span>
                    <mat-chip-set aria-label="All References">
                        @for (ref of item().RefNumbers; track ref) {
                            <mat-chip>
                                <span [highlight]="searchTerm()">{{ ref }}</span>
                            </mat-chip>
                        }
                    </mat-chip-set>
                </div>
            }
        </div>

        @if (item().ShippedDateTime) {
            <div class="detail-row">
                <div class="detail-item">
                    <mat-icon class="detail-icon">event</mat-icon>
                    <span class="detail-label text-muted">Shipped:</span>
                    <span class="detail-value">{{ parseDate(item().ShippedDateTime) | date: "longDate" }}</span>
                </div>
            </div>
        }
    </div>
</div>

<mat-menu #loadMenu="matMenu" xPosition="before" class="uni-search-menu-panel">
    <div class="d-flex flex-column">
        <button
            mat-menu-item
            class="d-flex align-items-center"
            (click)="$event.stopPropagation(); loadTrackButton()"
            [routerLink]="'dispatch/track/' + item().ID">
            <fa-icon class="text-primary" icon="location-arrow" size="lg"></fa-icon>
            <span>Load Track</span>
        </button>
        <button
            mat-menu-item
            class="d-flex align-items-center"
            (click)="$event.stopPropagation(); settlementButton()"
            [routerLink]="'dispatch/settlement/' + item().ID">
            <mat-icon color="primary" class="no-margin">account_balance</mat-icon>
            <span>Settlement</span>
        </button>
        <button
            mat-menu-item
            class="d-flex align-items-center"
            (click)="$event.stopPropagation(); orderGridButton()"
            [routerLink]="'dispatch/orders'"
            [queryParams]="{ LoadNumber: item().LoadNumber }">
            <mat-icon color="primary" class="no-margin">description</mat-icon>
            <span>Order Grid</span>
        </button>
        <button mat-menu-item class="d-flex align-items-center" (click)="$event.stopPropagation(); checkinButton()">
            <mat-icon color="primary" class="no-margin mat-green">event_available</mat-icon>
            <span>Checkin</span>
        </button>
    </div>
</mat-menu>
